import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  //
  // life cycle
  //
  initialize() {
    $("body").on("click", ".article-body h2", (e) => { this.urlCopy(e);});
    $("body").on("click", ".article-body h3", (e) => { this.urlCopy(e);});
    $("body").on("click", ".article-body h4", (e) => { this.urlCopy(e);});
  }

  //
  // target
  //
  static targets = [
  ]

  //
  // methods
  //
  urlCopy(e) {

    // 選択が発生している場合は実行しない。不思議な挙動になる。
    if (this.isSelecting(e)) {
      return;
    }

    const $head = $(e.target);
    const id = $head.attr("id");

    const href = location.href.split("#")[0];
    const url = href + "#" + id;
    const text = $head.text().substr(0, 5) + "…";

    const $tempTextArea = this.tempTextArea();
    $tempTextArea.val(url);
    $tempTextArea.select();
    document.execCommand("copy");
    $tempTextArea.remove();
    window.components.alertSlide.callByFunction("URLをコピーしました。" + text, "notice");

    // headをクリックした感を出す
    $head.addClass("style-active");
    this.timer1 = setTimeout(() => {
      $head.removeClass("style-active");
    }, 100 );


  }

  //
  // private
  //
  tempTextArea() {
    let $tempTextArea = $("#temp_text_area");
    if (!$tempTextArea[0]) {
      $("body").append("<textarea id='temp_text_area' style='position:fixed; left:-100%;'></textarea>");
      $tempTextArea = $("#temp_text_area");
    }
    return $tempTextArea;
  }

  isSelecting(e) {
    const head = e.target;
    let range = document.createRange();
    range.selectNodeContents(head);
    let selection = window.getSelection();
    // 選択の始点と終点が違う場合は、選択が発生している
    if (selection.baseOffset !== selection.focusOffset) {
      return true;
    } else {
      return false;
    }
  }
}
